import { render, staticRenderFns } from "./m_fillblanks.vue?vue&type=template&id=5ef3229f&scoped=true&"
import script from "./m_fillblanks.vue?vue&type=script&lang=js&"
export * from "./m_fillblanks.vue?vue&type=script&lang=js&"
import style0 from "./m_fillblanks.vue?vue&type=style&index=0&id=5ef3229f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3229f",
  null
  
)

export default component.exports